import { useState, useEffect, useRef, useCallback } from 'react';
import AddQuestionModal from './update-question-model';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useToast } from '../../Utils/toastContext';
import { debounce } from 'lodash';

export default function RiskAssessmentQuestionManagementTrigger({
  closeModal,
  pendingQuestions,
  completedQuestions,
}) {
  // const [questions, setQuestions] = useState(
  //   [
  //   {
  //     id: 1,
  //     question: "What services does your estate agency provide?",
  //     type: {
  //       value: 4,
  //       label: "Checkbox",
  //     },
  //     required: true,
  //     options: [
  //       "Acting as a buyer’s agent",
  //       "Acting as a seller’s agent",
  //       "Acting as a leasing agent (long term leases of 30+ years only)",
  //       "Short term leases or management of property",
  //     ],
  //   },
  //   {
  //     id: 2,
  //     question:
  //       "In your usual day to day business, what is the legal status of your clients?",
  //     type: {
  //       value: 3,
  //       label: "Select",
  //     },
  //     required: true,
  //     options: [
  //       "Individuals ",
  //       "Sole Traders",
  //       "Partnerships",
  //       "Trusts (including Family Trusts)",
  //     ],
  //   },
  //   {
  //     id: 3,
  //     question: "How are your clients conducting business?",
  //     type: {
  //       value: 5,
  //       label: "Checkbox With Percent",
  //     },
  //     required: true,
  //     options: [
  //       "Owner/occupier of the property",
  //       "Investment landlord, who might own up to 10 properties in Australia",
  //       "Small scale professional developer",
  //       "Large corporate developer",
  //     ],
  //   },
  //   {
  //     id: 4,
  //     question:
  //       "Does your agency typically receive money directly from clients for the purchase or leasing of property?",
  //     type: {
  //       value: 2,
  //       label: "Radio",
  //     },
  //     required: true,
  //     options: [
  //       "Yes (including cash or a direct bank transfer to the estate agency)",
  //       "No (all money transfers handled by conveyancer)",
  //     ],
  //   },
  //   {
  //     id: 5,
  //     question:
  //       "Please list the countries that your clients are typically from, and a very approximate % for each country. Please include Australia in the list.",
  //     type: {
  //       value: 5,
  //       label: "Checkbox With Percent",
  //     },
  //     required: true,
  //     options: [
  //       "Australia",
  //       "USA",
  //       "Afghanistan",
  //       "China",
  //       "India",
  //       "United Kingdom",
  //       "Other",
  //     ],
  //   },
  // ]);
  const { customerId } = useParams();
  const [search, setSearch] = useState('');
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [templateId, setTmplateId] = useState(false);

  const [isUpdate, setIsUpdate] = useState(false);
  const navigate = useNavigate();
  const { showToast } = useToast();

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [editingQuestion, setEditingQuestion] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const openAddModal = () => {
    setEditingQuestion(null);
    setShowModal(true);
  };
  const hasDefaultAlreadySent = () => {
    const existing = getAllExistingQuestions();

    const defaultQuestions = questions
      .filter((q) => q.isFromApi)
      .map((q) => q.question.trim().toLowerCase());

    return defaultQuestions.every((q) => existing.includes(q));
  };
  const openEditModal = (question) => {
    setEditingQuestion(question);
    setShowModal(true);
  };
  const [selected, setSelected] = useState('default');

  const options = [
    {
      id: 'default',
      title: 'Default Questions',
      desc: 'Send only system default questions',
    },
    {
      id: 'custom',
      title: 'Custom Questions',
      desc: 'Send only your custom questions',
    },
    {
      id: 'all',
      title: 'All Questions',
      desc: 'Send both default and custom questions',
    },
  ];
  const getAllExistingQuestions = () => {
    const all = [...(pendingQuestions || []), ...(completedQuestions || [])];

    return all.map((q) => q.question?.trim().toLowerCase());
  };
  const getNewQuestions = () => {
    return questions
      .filter((q) => !q.isFromApi) // only new ones
      .map((q) => q.question.trim().toLowerCase());
  };
  const hasNewQuestions = () => {
    return questions.some((q) => !q.isFromApi);
  };
  const hasDuplicateQuestions = () => {
    const existingQuestions = getAllExistingQuestions();
    const newQuestions = getNewQuestions();
    return newQuestions.some((q) => existingQuestions.includes(q));
  };
  const handleSelect = (id) => {
    setSelected(id);
  };
  const handleDelete = (id) => {
    const updatedQuestions = questions.filter((q) => q.id !== id);
    setQuestions(updatedQuestions);
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === 'object' && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const filteredQuestions = questions.filter((q) =>
    q.question.toLowerCase().includes(search.toLowerCase()),
  );
  const capitalizeFirst = (text) => {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
  };
  const mapApiToUI = (questions) => {
    return questions.map((q) => ({
      id: q.id,
      question: q.question_text,
      type: {
        value: q.type.id,
        label: capitalizeFirst(q.type.value),
      },
      required: q.required,
      options: (q.options || []).map((opt) => ({
        label: opt,
      })),
      isFromApi: true, // 👈 IMPORTANT FLAG
    }));
  };
  const getDuplicateQuestions = () => {
    const existing = getAllExistingQuestions();
    const newQs = getNewQuestions();

    return newQs.filter((q) => existing.includes(q));
  };
  const formatName = (name) => {
    if (!name) return '';

    return name
      .replace(/_/g, ' ') // replace underscores with space
      .toLowerCase() // make all lowercase first
      .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize each word
  };
  const getQuestions = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/agency/edd-templates`);

      if (response.status == 200) {
        if (response.data.length > 0) {
          const formattedQuestions = mapApiToUI(response.data[0].questions);
          setQuestions(formattedQuestions);
          setTmplateId(response.data[0].id);
          if (response.data[0].id) {
            setIsUpdate(true);
          } else {
            setIsUpdate(false);
          }
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setTimeout(function () {}, 100);
    }
  };
  const transformQuestion = (q, index) => ({
    question_type_id: q.type.value,
    question_text: q.question.trim(),
    order: index + 1,
    required: q.required,
    options: q.options || [],
  });
  const sendEdd = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agent/customers/review/${customerId}/edd`;
    let bodyData = {};
    if (selected === 'default') {
      bodyData = {
        template_id: templateId,
      };
    } else if (selected === 'custom') {
      bodyData = {
        questions: questions
          .filter((q) => !q.isFromApi) // 👈 ONLY NEW
          .map(transformQuestion),
      };
    } else {
      if (hasDefaultAlreadySent()) {
        bodyData = {
          questions: questions
            .filter((q) => !q.isFromApi) // 👈 ONLY NEW
            .map(transformQuestion),
        };
      } else {
        bodyData = {
          template_id: templateId,
          questions: questions
            .filter((q) => !q.isFromApi) // 👈 ONLY NEW
            .map(transformQuestion),
        };
      }
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const UpdateQuestion = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agency/edd-templates/${templateId}`;
    const bodyData = {
      name: 'EDD Template',
      questions: questions.map(transformQuestion),
      is_default: true,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleQuestions = useCallback(
    debounce(async (e) => {
      e.preventDefault();

      setLoading(true);

      try {
        const response = await sendEdd();

        if (response.status === 201) {
          closeModal();
          showToast(response.message, 'success');
        } else {
          showToast(response.message || 'Something went wrong', 'error');
        }
      } catch (err) {
        showToast(err.message || 'Network error', 'error');
      } finally {
        setLoading(false);
      }
    }, 500), // reduced debounce for better UX
    [isUpdate, getQuestions, questions], // ✅ correct dependencies
  );
  useEffect(() => {
    getQuestions();
  }, []);
  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw] h-[90vh] flex flex-col text-sm">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="p-4 bg-gray-50 font-medium flex flex-col h-full">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          {/* LEFT: Heading */}
          <h1 className="text-2xl text-gray-800">
            ECDD Questions (Enhanced Customer Due Diligence)
          </h1>

          {/* RIGHT: Buttons */}
          <div className="flex items-center space-x-3">
            <button
              onClick={openAddModal}
              className="bg-[#375AE7] text-white px-4 py-2 rounded-lg hover:bg-[#2f4ed8]"
            >
              + Add Question
            </button>

            <button onClick={closeModal} className="text-black text-xl px-2">
              ×
            </button>
          </div>
        </div>

        {/* Search */}
        <div className="mb-4">
          <input
            type="text"
            placeholder="Search question..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full md:w-96 border rounded-lg px-4 py-2 focus:ring-2 focus:ring-[#375AE7]"
          />
        </div>

        {/* Table */}
        <div className="bg-white shadow rounded-xl overflow-hidden flex-1 flex flex-col">
          <div className="overflow-y-auto">
            {' '}
            <table className="w-full text-left">
              <thead className="bg-gray-100 text-labelLightColour text-sm">
                <tr>
                  <th className="p-4">Question</th>
                  <th className="p-4">Type</th>
                  <th className="p-4">Required</th>
                  <th className="p-4 text-right">Actions</th>
                </tr>
              </thead>

              <tbody>
                {filteredQuestions.length > 0 ? (
                  filteredQuestions.map((q) => (
                    <tr
                      key={q.id}
                      className="border-t hover:bg-gray-50 transition"
                    >
                      <td className="p-4">{q.question}</td>
                      <td className="p-4">{formatName(q.type.label)}</td>
                      <td className="p-4">
                        {q.required ? (
                          <span className="text-green-600 font-medium">
                            Yes
                          </span>
                        ) : (
                          'No'
                        )}
                      </td>

                      <td className="p-4 text-right space-x-3">
                        <button
                          onClick={() => openEditModal(q)}
                          disabled={q.isFromApi}
                          className={`${
                            q.isFromApi
                              ? 'text-gray-400 cursor-not-allowed'
                              : 'text-[#375AE7] hover:underline'
                          }`}
                        >
                          <span className="material-symbols-outlined mr-2 text-xl">
                            edit
                          </span>
                        </button>

                        <button
                          onClick={() => !q.isFromApi && handleDelete(q.id)}
                          disabled={q.isFromApi}
                          className={`${
                            q.isFromApi
                              ? 'text-gray-400 cursor-not-allowed'
                              : 'text-red-500 hover:underline'
                          }`}
                        >
                          <span className="material-symbols-outlined mr-2 text-xl">
                            delete
                          </span>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center p-4 text-gray-500">
                      No question added
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {showModal && (
          <AddQuestionModal
            close={() => setShowModal(false)}
            getQuestions={getQuestions}
            setQuestions={setQuestions}
            existingQuestions={questions}
            questionData={editingQuestion}
          />
        )}
        <div className="flex items-center justify-between mt-4 mb-2">
          <h3 className="text-sm font-medium text-gray-700">
            Select Questions to Send
          </h3>

          <div className="flex items-center bg-gray-100 rounded-full p-1">
            {options.map((opt) => {
              const isActive = selected === opt.id;

              return (
                <button
                  key={opt.id}
                  onClick={() => handleSelect(opt.id)}
                  className={`px-3 py-1 text-xs rounded-full transition-all duration-200
            ${
              isActive
                ? 'bg-[#375AE7] text-white shadow-sm'
                : 'text-gray-600 hover:text-[#375AE7]'
            }`}
                >
                  {opt.title}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {(questions.length > 0 || isUpdate) && (
        <div className="bg-[#375AE7] p-4 mt-auto">
          <div className="flex items-center space-x-4">
            <div
              onClick={(e) => {
                e.preventDefault();
                if (selected === 'custom' || selected === 'all') {
                  if (!hasNewQuestions()) {
                    showToast(
                      'No new questions added. Please add at least one question before sending.',
                      'error',
                    );
                    return;
                  }
                }
                if (hasDuplicateQuestions()) {
                  showToast(
                    'Some questions already exist in pending or completed requests. Please remove duplicates before submitting.',
                    'error',
                  );
                  return;
                }
                if (selected === 'default') {
                  if (hasDefaultAlreadySent()) {
                    showToast(
                      'Default questions already sent for this customer.',
                      'error',
                    );
                    return;
                  }
                }

                setLoading(true);
                handleQuestions(e);
              }}
              className="flex border ml-6 rounded-full items-center space-x-2 text-sm md:text-md font-medium py-1 px-8 text-white cursor-pointer"
            >
              <span>Send to customer</span>
            </div>
            <div
              onClick={(e) => {
                e.preventDefault();
                getQuestions();
              }}
              className="flex border ml-6 rounded-full items-center space-x-2 text-sm md:text-md font-medium py-1 px-8 text-white cursor-pointer"
            >
              <span>Reset</span>
            </div>
            <button
              className="px-8 py-1 border text-sm rounded-full mr-2 text-white border-white"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
